import Container from "components/Container/Container";
import React from "react";

function SMSTemplate() {
  return <Container title="SMS Template"></Container>;
}

export default SMSTemplate;
